import React from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import { Flex } from '@osmosis/react-ui/components/Box';
import { FormattedMessage } from 'react-intl';
import { QuizRecommendedConcept } from '../../types/quiz';
import VideoList from '../VideoList';
import Divider from '../Divider';

type Props = {
  relevantVideos: QuizRecommendedConcept[];
  showRelevantContent: boolean;
};

/**
 * QuizRelevantContent.
 *  @returns The sidebar component for the Quiz page.
 */
const QuizRelevantContent = ({
  relevantVideos,
  showRelevantContent,
}: Props) => {
  if (!showRelevantContent) {
    return null;
  }

  return (
    <Box
      className="border border-gray-300 rounded-lg w-full max-h-[700px] flex flex-col max-lg:hidden"
      data-testid="quiz-relevant-content"
    >
      <Box className="p-4 pb-2 flex-shrink-0">
        <Flex className="items-center pb-2">
          <span className="font-bold text-lg text-neutral-800">
            <FormattedMessage
              defaultMessage="Related videos and concepts"
              id="loggedout_quiz_relevant_content.title"
            />
          </span>
        </Flex>
        <Divider className="-mr-1 bg-gray-300 h-px" />
      </Box>
      <Box className="overflow-auto p-2 flex-grow">
        <VideoList
          testId="logged-out-quiz-video-list"
          videos={relevantVideos}
        />
      </Box>
    </Box>
  );
};

export default QuizRelevantContent;
